import React from 'react';
import PropTypes from 'prop-types';

import './ModalsContainer.sass';

import {connect} from 'react-redux';

import {closeModal} from '../../ducks/ui';

import {Helmet} from 'react-helmet';
import {CSSTransitionGroup} from 'react-transition-group';
import CartModalContainer from '../cartModalContainer/CartModalContainer';

@connect(({ui}) => ({modal: ui.modal}), {closeModal})
export default class ModalsContainer extends React.PureComponent {
  static modals = [
    CartModalContainer
  ];

  render() {
    const {modal, closeModal} = this.props;

    return (
      <div>
        {(modal && modal.name) && (
          <Helmet>
            <body className="prevent-scroll"/>
          </Helmet>
        )}

        <CSSTransitionGroup
          component="div"
          transitionName="modal"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {ModalsContainer.modals.map(ModalComponent => modal.name !== ModalComponent.modalName ? null : (
            <ModalComponent key={ModalComponent.modalName} onClose={closeModal} {...modal.data}/>
          ))}
        </CSSTransitionGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/modalsContainer/ModalsContainer.js